import { DevelopmentStages, FeeUnits, PricingType, StorageFeeUnits, UnitDecimals } from '~/constants';
import { Project } from '~/types/project';
import { formatDollars } from '~/utils/formatNumber';
import { display } from '../../common';


export const buyerFeeLabels = (project: Project, feeData: any) => {
  const { nrsFee, nrsFeeUnit } = feeData || {};

  let feeLabel: string = '';
    if (nrsFee) {
      if (project?.pricingType === PricingType.ITC || nrsFeeUnit === FeeUnits.PERCENT_OF_ITC) {
        feeLabel = `${nrsFee}% of ITC value`;
      }
      if (nrsFeeUnit === FeeUnits.PERCENT_OF_BUDGET) {
        feeLabel = `${nrsFee}% of budget`;
      }
      if (nrsFeeUnit === FeeUnits.PERCENT_OF_BUDGET && project.developmentStage === DevelopmentStages.OPERATING) {
        feeLabel = `${nrsFee}% of project acquisition cost`;
      }
      if (nrsFeeUnit === FeeUnits.DOLLARS_PER_WDC) {
        feeLabel = `${formatDollars(nrsFee, { dec: UnitDecimals.WDC })} / Wdc`;
      }
      if (nrsFeeUnit === FeeUnits.FLAT_FEE) {
        feeLabel = `${formatDollars(nrsFee)} as flat fee`;
      }
    } else {
      return display(undefined);
    }
  
  return feeLabel;
};

export const buyerStorageFeeLabels = (feeData: any) => {
  const { buyerStorageFee, buyerStorageFeeUnit } = feeData || {};

  let storageFeeLabel: string = '';
  if (buyerStorageFee) {
    if (buyerStorageFeeUnit === StorageFeeUnits.DOLLARS_PER_KWH) {
      storageFeeLabel = `${formatDollars(buyerStorageFee, { dec: UnitDecimals.KWH_BESS })} / kWh`;
    }
    if (buyerStorageFeeUnit === StorageFeeUnits.FLAT_FEE) {
      storageFeeLabel = `${formatDollars(buyerStorageFee)} as flat fee`;
    }
  } else {
    return display(undefined);
  }

  return storageFeeLabel;
};